//V2 changes for utility functions of share want ad

import { capitalizeFirstString } from "./common";

export const getPropertyTextShare = (adDetails) => {
  if (adDetails?.prprtyType === 13) {
    return capitalizeFirstString(adDetails?.prptySubTypesTxt[0]||"");
  } else {
    return capitalizeFirstString(adDetails.prptyTypeTxt||"");
  }
};

export const getAdTypeTextShare = (adType) => {
  if (adType === "BUY") {
    return "Looking to buy";
  } else if (adType === "LTR") {
    return "Looking to rent";
  } else if (adType === "STR") {
    return "Stay in";
  }
};

export const getPropertyArticle = (propertyText) => {
  // Ensure propertyText is a string, fallback to empty string
  const text = typeof propertyText === "string" ? propertyText.trim() : "";

  if (!text) {
    return ""; // Return an empty string if the input is invalid
  }

  // Words starting with vowel sounds need "an"
  const vowelSounds = ["a", "e", "i", "o", "u"];
  return vowelSounds.includes(text.toLowerCase().charAt(0)) ? "an" : "a";
};
